import { FlowType } from "../components/technical/upload";
import { postRequest } from "../utils/fetch";
import { StoreType } from "./storageService";

export interface IDownloadStatusResult {
	readonly fileId: string;
	readonly status: number;
	readonly info: string;
	readonly originalFileName: string;
}

export interface IPartnerPhotoData {
	/** Mediastore file Id*/
	readonly Id?: string;
	/** Partner ref string*/
	readonly Code: string;
	readonly ImageFilename: string;
	readonly StoreType: StoreType;
	readonly ImageUrl: string;
}

export class DownloadService {
	private token: string;
	protected baseUrl: string;
	private productCategoryGroup: string;

	constructor(token: string, productCategoryGroup: string) {
		this.baseUrl = window.context.ecomApiUrl + "/mediastore/accounts";
		this.productCategoryGroup = productCategoryGroup;
		this.token = token;
	}

	public async createDownloadSessionForPartnerPhotosAsync(
		partnerPhotoData: IPartnerPhotoData[],
		pointOfSaleId: string,
		accountId: string,
		language: string,
		flowType: FlowType,
		folderId?: string,
	): Promise<boolean> {
		const data = {
			pointOfSaleId,
			languageISO: language,
			downloads: partnerPhotoData.map((pd) => {
				return { ...pd, ImageUrl: pd.StoreType === StoreType.GooglePhotos ? `${pd.ImageUrl}|${pd.Code}` : pd.ImageUrl };
			}),
			flow: flowType.toString(),
			productCategoryGroup: this.productCategoryGroup,
			folderId,
		};

		return await postRequest<object, boolean>(`${this.baseUrl}/${accountId}/download/sessions`, data, {
			headers: {
				Authorization: "ExpressForms " + this.token,
				"Content-type": "application/json; charset=utf-8",
				Cookies: document.cookie,
			},
		});
	}

	public async downloadPartnerCheckStatusFilesAsync(
		fileIdsToCheck: string[],
		accountId: string,
	): Promise<IDownloadStatusResult[]> {
		return await postRequest<string[], IDownloadStatusResult[]>(
			`${this.baseUrl}/${accountId}/download/sessions/status`,
			fileIdsToCheck,
			{
				headers: {
					Authorization: "ExpressForms " + this.token,
					"Content-type": "application/json; charset=utf-8",
					Cookies: document.cookie,
				},
			},
		);
	}
}
